import { render, staticRenderFns } from "./PackageExpert.vue?vue&type=template&id=7a9eed8d&scoped=true&"
import script from "./PackageExpert.vue?vue&type=script&lang=js&"
export * from "./PackageExpert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9eed8d",
  null
  
)

export default component.exports